export const getLinkedSystemLabel = (row: Record<string, unknown>): string => {
  const candidates = [row.description, row.systemName, row.name];
  const match = candidates.find((value) => typeof value === "string" && value.trim());
  return typeof match === "string" ? match.trim() : "";
};

export const getLinkedSystemLabels = (rows: readonly Record<string, unknown>[]): string[] => {
  const labels = new Set<string>();
  rows.forEach((row) => {
    const label = getLinkedSystemLabel(row);
    if (label) labels.add(label);
  });
  return [...labels];
};

export const includeCurrentOption = (options: readonly string[], current?: string): string[] => {
  const unique = [...new Set(options.filter(Boolean))];
  const trimmed = current?.trim();
  if (trimmed && !unique.includes(trimmed)) return [trimmed, ...unique];
  return unique;
};
